module.exports = __webpack_public_path__ + "img/4.7c77e1a8.jpg";